/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';

interface TicketProps {
  title?: string;
}

/**
 * This is the Ticket component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Ticket({ title = 'Ticket' }: TicketProps) {
  return (
    <span className="svg svg-square svg-ticket">
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          x="0"
          y="0"
          viewBox="0 0 25 25"
          enableBackground="new 0 0 25 25"
          xmlSpace="preserve"
          aria-hidden="true"
        >
          <title>{title}</title>
          <path
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            d="M22.5 6.5h-20v3.7c0.8 0 2 0.6 2 2.2 0 1.9-1.5 2.4-2 2.4v3.7h20v-3.7c-0.9 0-2.2-0.3-2.2-2.4 0-1.9 1.4-2.2 2.2-2.2V6.5z"
          />
        </svg>
      </span>
    </span>
  );
}

export default Ticket;
